'use strict';

angular.module('ClinicApp').factory('ProviderAvailabilityBlockService', function($http, ClinicConfig) {

  return {

    create: function(providerId, startDate, startTime, endTime, available, recurring, type) {
      return $http.post(ClinicConfig.HOSTNAME + '/provider/' + providerId + '/availabilityBlock', {
        startDate: startDate,
        startTime: startTime,
        endTime: endTime,
        available: available,
        recurring: recurring,
        type: type,
      }).then(function(response) {
        return response.data;
      });
    },

    createForClinic: function(clinicId, startDate, startTime, endTime, available, recurring, type) {
      return $http.post(ClinicConfig.HOSTNAME + '/clinic/' + clinicId + '/availabilityBlock', {
        startDate: startDate,
        startTime: startTime,
        endTime: endTime,
        available: available,
        recurring: recurring,
        type: type,
      }).then(function(response) {
        return response.data;
      });
    },

    createException: function(providerId, providerAvailabilityBlockId, date) {
      return $http.post(ClinicConfig.HOSTNAME
        + '/provider/' + providerId
        + '/availabilityBlock/' + providerAvailabilityBlockId + '/exception', {
        date: date,
      }).then(function(response) {
        return response.data;
      });
    },

    find: function(providerId) {
      return $http.get(ClinicConfig.HOSTNAME + '/provider/' + providerId + '/availabilityBlock').then(function(response) {
        return response.data;
      });
    },

    listForClinic: function(clinicId) {
      return $http.get(ClinicConfig.HOSTNAME + '/clinic/' + clinicId + '/availabilityBlock').then(function(response) {
        return response.data;
      });
    },

    remove: function(providerId, providerAvailabilityBlockId) {
      return $http['delete'](ClinicConfig.HOSTNAME + '/provider/'
        + providerId + '/availabilityBlock/' + providerAvailabilityBlockId).then(function(response) {
        return response.data;
      });
    },
  };
});
